export const staticTh = {
    point_stepModal: {
        title: 'วิธีสะสมพอยท์',
        stepOne: {
            no: '1.',
            textPink: 'หา QR Code',
            textGray: 'ที่มีสัญลักษณ์',
            textGray2: 'ข้างขวดหรือกล่อง'
        },
        stepTwo: {
            no: '2.',
            text_qr_old_pink: 'ขูดด้วยเหรียญ',
            text_qr_old_gray: '(สำหรับ QR Code แบบเก่า) หรือ',
            text_qr_new_pink: 'ดึงสติ๊กเกอร์',
            text_qr_new_gray: 'ขึ้น (สำหรับ QR Code แบบใหม่)',
        },
        stepThree: {
        no: '3.',
        textGray: 'กดที่เมนู',
        textPink: '" สะสมพอยท์ "'
        },
        stepFour: {
            no: '4. ',
            textPink: 'สแกน QR Code, อัพโหลดรูป QR Code หรือ กรอก Code ด้วยมือ และ เลือกร้านค้า',//'สแกน QR Code และ เลือกร้านค้า',
            textGray: 'ที่ท่านซื้อมา'
        },
    },

    about_us: {
        title_topbar: 'เกี่ยวกับเรา',
        title_company: 'Our company',
        text_detail_company: 'BIODERMA เป็นแบรนด์ของ NAOS ที่หลงใหลในชีววิทยาเกี่ยวกับผิวมากว่า 40 ปี เราได้สร้างนวัตกรรมและเข้าไปมีส่วนร่วมในความก้าวหน้าทางการดูแลสุขภาพผิวที่ดี ทำให้เราเป็นผู้ที่มีความชำนาญและเป็นผู้นำทางเวชสำอาง',
        title_proficient: 'ความเชี่ยวชาญของเรา : ชีววิทยาของผิว',
        text_detail: 'พันธกิจของเรา คือ การนำชีววิทยาเข้ามาใช้ในการดูแลผิวเพื่อสุขภาพผิวที่ดี โดยมีการทำงานร่วมกับผู้เชี่ยวชาญด้านสุขภาพจากทั่วโลก เราช่วยให้ผิวแข็งแรงขึ้น ไม่ว่าจะเป็นผิวแพ้ง่ายหรือผิวที่ต้องเผชิญกับสภาพแวดล้อมแบบใดก็ตาม',
    },

    contact: {
        title_topbar: 'ติดต่อเรา',
        title_company: 'บริษัท นาโอส (ประเศไทย) จำกัด',
        text_detail_address: 'ชั้น 1 อาคารเพลินจิต เซ็นเตอร์ เลขที่ 2 ถ.สุขุมวิท แขวงคลองเตย เขตคลองเตย กรุงเทพมหานคร 10110',
        tel: 'Tel. 02-2522979',
        email: 'E-mail: naosthailand@gmail.com',
        time: 'Open hour: 9.00 - 18.00',
    },

    privacy: {
        title_topbar: 'นโยบายความเป็นส่วนตัว',
    },
    terms: {
        title_topbar: 'เงื่อนไขในการใช้สิทธิพิเศษ',
    },
    marketing: {
        title_topbar: 'ข่าวสารและโปรโมชั่น',
        tile_msg: 'ยอมรับข่าวสารและโปรโมชั่น<br/>โปรดเลือกอย่างน้อย 1 ช่องทาง',
        all: 'ทั้งหมด',
        email: 'Email',
        sms: 'SMS',
        line: 'LINE',
        btn_accept: 'ยอมรับ',

        modal: {
            title: 'ไม่รับข่าวสารและโปรโมชั่น',
            msg: 'คุณอาจเสียโอกาสในการรับข่าวสาร<br/>โปรโมชั่นและสิทธิพิเศษของเราได้',
            btn_accept: 'ตั้งค่าช่องทางการรับข่าวสาร',
            btn_unaccept: 'ไม่รับข่าวสารและโปรโมชั่น'
        },

        title_alert: 'บันทึกการรับข่าวสารสำเร็จ',
        detail_text: 'คุณได้ทำการบันทึกการตั้งค่าข้อมูลการรับข่าวสารเรียบร้อยแล้ว',
        btn_close: 'ปิด'
    }
}
